// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2yXOE","head":"ProcedureTableInfo_head__eJ-BJ"};